import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { ArrowDownIcon } from '../icons/arrow-down-icon';
import styles from './select-mobile.scss';

const classNames = require('classnames');

class SelectMobile extends React.Component {
  constructor(props) {
    super(props);
    this.state = { currentOption: props.options[0].label };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.defaultValue !== this.props.defaultValue) {
      this.setState({ value: nextProps.defaultValue });
    }
  }

  handleChange = (event) => {
    const selectedOption = this.props.options.find((o) => o.value === event.target.value);
    this.setState({ currentOption: selectedOption.label });
    this.props.onChange(event.target.value);
  };

  renderOptions() {
    return _.map(this.props.options, ({ value, label }) => (
      <option key={value} value={value} name={label}>
        {label}
      </option>
    ));
  }

  render() {
    const { defaultValue } = this.props;
    return (
      <div className={styles.container}>
        <span className={classNames(styles.currentOption, 'ma-font-body-m')}>{this.state.currentOption}</span>
        <ArrowDownIcon className={classNames(styles.selectIcon, 'ma-members-list-icon-color')} />
        <select
          className={classNames(styles.select, 'ma-font-body-m', 'select-mobile__select')}
          onChange={this.handleChange}
          defaultValue={defaultValue}
        >
          {this.renderOptions()}
        </select>
      </div>
    );
  }
}

SelectMobile.propTypes = {
  defaultValue: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.any.isRequired,
    }),
  ),
};

export default SelectMobile;
